import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { convertQueryObjToString, mapQueryStringToFilterObject } from '@components-web/filters/helper';
import { pageSizeOptions } from '@constants/generic-constants';

const usePagination = ({ pagination }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const defaultPageSize = pageSizeOptions?.[0];

  const [currentPage, setCurrentPage] = useState(pagination?.current_page || 1);
  const shouldPaginate = pagination?.total_count > defaultPageSize || false;

  useEffect(() => {
    const { queryObj } = mapQueryStringToFilterObject(location.search);
    const page = Number(queryObj['page'] || pagination?.current_page || 1);
    setCurrentPage(page);
  }, [location.search, pagination?.current_page]);

  const handlePageChange = ({ page, size, setPageSize }) => {
    setCurrentPage(page);
    setPageSize(size);
    const container = document.getElementsByClassName('main-content')?.[0];
    container.scroll({ top: 0 });
    const { queryObj } = mapQueryStringToFilterObject(location.search);
    queryObj['page'] = page;
    const newQueryString = convertQueryObjToString(queryObj);
    navigate(
      {
        search: `?${newQueryString}`,
      },
      {
        state: location.state,
      }
    );
  };

  return {
    currentPage,
    handlePageChange,
    shouldPaginate,
  };
};

export default usePagination;
